// import store from '@/store';
// import moment from "moment";
import consts from "@/consts";
// import DriverScoreCards from "@/components/drivers/score-cards/DriverScoreCards.vue";
import emptyRouteComponent from "@/components/_base/EmptyRouteComponent";

const defaultSetRoute = {
    drivers: (route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.drivers.main) {
            if(this.$isDevelopment) console.warn('drivers', route);
            return false
        }
        router.push({
            name: consts.routerNames.drivers.main,
            params: {},
            query: {...route.query},
        })
    },
    driverId: (route, router, driverId, groupId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.drivers.main) {
            if(this.$isDevelopment) console.warn('driverId', route);
            return false
        }
        if(groupId) {
            router.push({
                name: consts.routerNames.drivers.group.driverId,
                params: {
                    groupId,
                    driverId,
                },
                query: {...route.query},
            })
        } else {
            router.push({
                name: consts.routerNames.drivers.id,
                params: {
                    driverId,
                },
                query: {...route.query},
            })
        }
    },
    driverFilter: (route, router, filter) => {
        if(route.meta?.mainRouteName !== consts.routerNames.drivers.main) {
            if(this.$isDevelopment) console.warn('driverFilter', route);
            return false
        }
        router.push({
            name: route.name,
            query: {...filter},
        })
    },
    driverEdit: (route, router, driverId, groupId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.drivers.main) {
            if(this.$isDevelopment) console.warn('driverEdit', route);
            return false
        }
        if(groupId) {
            router.push({
                name: consts.routerNames.drivers.group.driverEdit,
                params: {
                    groupId,
                    driverId,
                },
                query: {...route.query},
            })
        } else {
            router.push({
                name: consts.routerNames.drivers.edit.main,
                params: {
                    driverId,
                },
                query: {...route.query},
            })
        }
    },
    driverGroupEdit: (route, router, groupId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.drivers.main) {
            if(this.$isDevelopment) console.warn('driverGroupEdit', route);
            return false
        }
        router.push({
            name: consts.routerNames.drivers.group.edit,
            params: {
                groupId,
            },
            query: {...route.query},
        })
    },
    driverGroupId: (route, router, groupId) => {
        if(route.meta?.mainRouteName !== consts.routerNames.drivers.main) {
            if(this.$isDevelopment) console.warn('driverGroupId', route);
            return false
        }
        if(!groupId) groupId = 0;
        router.push({
            name: consts.routerNames.drivers.group.id,
            params: {
                groupId,
            },
            query: {...route.query},
        })
    },
    returnToParent:(route, router) => {
        if(route.meta?.mainRouteName !== consts.routerNames.drivers.main) {
            if(this.$isDevelopment) console.warn(consts.routerNames.drivers.main+' returnToParent', route);
            return false;
        }
        let name = route.meta?.parentRouteName || consts.routerNames.drivers.main;
        router.push({
            name: name,
            params: {
                ...route.params,
            },
            query: {...route.query}
        })
    },
}

const routes = (process.env.VUE_APP_PACKAGE !== 'prometheus.portal') ? [] : [
    {
        path: 'drivers',
        name: consts.routerNames.drivers.main,
        meta: {
            list: 'DriversList',
            mainRouteName: consts.routerNames.drivers.main,
            pageLayout: 'page-global',
            pageClass: 'drivers-page',
            showMap: true,
            layers: {
                ...consts.defaultSettingsLayers,
                units: {visible: false, showInList: false, showLayer: false},
                geoitems: {visible: false, showInList: false, showLayer: false},
            },
            setRoute: defaultSetRoute,
        },
        component: () => import('@/views/prometheus/portal/DriversPage.vue'),
        children: [
            {
                path: ':driverId(\\d+)',
                name: consts.routerNames.drivers.id,
                meta: {
                    mainRouteName: consts.routerNames.drivers.main,
                    parentRouteName: consts.routerNames.drivers.main,
                },
                props: {
                    default: function (route) {
                        return {driverId: route.params.driverId}
                    },
                },
                components: {
                    default: emptyRouteComponent,
                },
                children: [
                    {
                        path: 'edit',
                        name: consts.routerNames.drivers.edit.main,
                        meta: {
                            mainRouteName: consts.routerNames.drivers.main,
                            parentRouteName: consts.routerNames.drivers.id,
                            blockingRoutesTransitionFromOutside: true,
                            sectionInfoByRoute: true,
                        },
                        props: {
                            sectionInfoByRoute: (route) => ({
                                driverId: +route.params.driverId,
                                time: Date.now(),
                                editClass: 'section__content-wrapper-pm'
                            })
                        },
                        components: {
                            sectionInfoByRoute: () => import('@/components/drivers/driver-edit/DriverEdit.vue'),
                        },
                        children: []
                    }
                ]
            },
            {
                path: 'group/:groupId(\\d+)',
                name: consts.routerNames.drivers.group.id,
                meta: {
                    mainRouteName: consts.routerNames.drivers.main,
                    parentRouteName: consts.routerNames.drivers.main,
                },
                props: {
                    default: function (route) {
                        return {groupId: route.params.groupId}
                    },
                },
                components: {
                    default: emptyRouteComponent,
                },
                children: [
                    {
                        path: ':driverId(\\d+)',
                        name: consts.routerNames.drivers.group.driverId,
                        meta: {
                            mainRouteName: consts.routerNames.drivers.main,
                            parentRouteName: consts.routerNames.drivers.group.id,
                        },
                        props: {
                            default: function (route) {
                                return {groupId: route.params.groupId, driverId: route.params.driverId}
                            },
                        },
                        components: {
                            default: emptyRouteComponent,
                        },
                        children: [
                            {
                                path: 'edit',
                                name: consts.routerNames.drivers.group.driverEdit,
                                meta: {
                                    mainRouteName: consts.routerNames.drivers.main,
                                    parentRouteName: consts.routerNames.drivers.group.driverId,
                                    blockingRoutesTransitionFromOutside: true,
                                    sectionInfoByRoute: true,
                                },
                                props: {
                                    sectionInfoByRoute: (route) => ({
                                        driverId: +route.params.driverId,
                                        time: Date.now(),
                                        editClass: 'section__content-wrapper-pm'
                                    })
                                },
                                components: {
                                    sectionInfoByRoute: () => import('@/components/drivers/driver-edit/DriverEdit.vue'),
                                },
                                children: []
                            }
                        ]
                    },
                    {
                        path: 'edit',
                        name: consts.routerNames.drivers.group.edit,
                        meta: {
                            mainRouteName: consts.routerNames.drivers.main,
                            parentRouteName: consts.routerNames.drivers.group.id,
                            blockingRoutesTransitionFromOutside: true,
                            sectionInfoByRoute: true,
                        },
                        props: {
                            sectionInfoByRoute: (route) => ({
                                driversGroupId: +route.params.groupId,
                                time: Date.now(),
                                editClass: 'section__content-wrapper-pm'
                            })
                        },
                        components: {
                            sectionInfoByRoute: () => import('@/components/drivers/driver-groups-edit/DriversGroupEdit.vue'),
                        },
                        children: []
                    },
                ]
            },
        ]
    },
];

export default routes;